import { useSelector } from 'react-redux'
import { HEADER_DEFAULT_HEIGHT_PE, HEADER_SUBHEADER_HEIGHT } from '../header/header-constants'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { isUIElementDisplayed, selectHeaderHeight } from '../../store/ui/ui.selectors'

const useComputedHeaderHeight = (menuCategoriesPE, subHeaderComponent) => {
  const headerHeight = useSelector(selectHeaderHeight)
  const suggestDisplayed = useSelector(isUIElementDisplayed(UI_ELEMENTS.SUGGEST))
  const searchDialogDisplayed = useSelector(isUIElementDisplayed(UI_ELEMENTS.SEARCH_DIALOG))

  const subHeaderHeigth =
    !suggestDisplayed && !searchDialogDisplayed && subHeaderComponent ? HEADER_SUBHEADER_HEIGHT : 0

  const shouldDisplayMenuCategoriesPE = menuCategoriesPE && !suggestDisplayed && !searchDialogDisplayed

  const menuHeigth = shouldDisplayMenuCategoriesPE ? HEADER_DEFAULT_HEIGHT_PE : 0

  return headerHeight + subHeaderHeigth + menuHeigth
}

export default useComputedHeaderHeight
